import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { InventoryCell } from '..';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import "./latestinventorycontainer.css";

const LatestInventoryContainer = () => {
    const [newInventoryData, setNewInventoryData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 16;

    const fetchRecentData = () => {
        axios.get('https://ohp.rockycoastlabs.xyz/getRecent.php')
            .then(response => {
                console.log(response.data)
                setNewInventoryData(response.data);
            })
            .catch(error => {
                console.error("Error fetching data:", error);
            });
    }

    useEffect(() => {
        fetchRecentData();
    }, []);

    // Reset to first page when data changes
    useEffect(() => {
        setCurrentPage(1);
    }, [newInventoryData]);

    const totalPages = Math.ceil(newInventoryData.length / itemsPerPage);
    const startIdx = (currentPage - 1) * itemsPerPage;
    const endIdx = startIdx + itemsPerPage;
    const paginatedItems = newInventoryData.slice(startIdx, endIdx);

    const handlePageChange = (newPage) => {
        const clampedPage = Math.max(1, Math.min(newPage, totalPages));
        setCurrentPage(clampedPage);
        // Scroll to top of inventory container
        const container = document.querySelector('.inventory-cell-container');
        if (container) {
            container.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div>
            <Container className='inventory-cell-container'>
                <Row><h1 className='ps-4 pb-3'>Latest Inventory</h1></Row>
                <Row xs={1} sm={2} lg={3} xl={4}>
                    {newInventoryData.length > 0 ? (
                        paginatedItems.map(item => (
                            <Col className="inventory-list" key={item.id}>
                                <InventoryCell item={item} />
                            </Col>
                        ))
                    ) : (
                        <Col className='m-auto'>
                            <h5 className='no-items-message text-center'>Unfortunately we don't have any of these items available online at the moment.
                                Contact us if you have a specific item you are looking for.</h5>
                        </Col>
                    )}
                </Row>
                {/* Pagination Controls */}
                {newInventoryData.length > itemsPerPage && (
                    <Row className="justify-content-center mt-4">
                        <Col xs="auto">
                            <button
                                className="btn btn-secondary me-2"
                                onClick={() => handlePageChange(currentPage - 1)}
                                disabled={currentPage === 1}
                            >
                                Previous
                            </button>
                            <span className="align-middle mx-2">
                                Page {currentPage} of {totalPages}
                            </span>
                            <button
                                className="btn btn-secondary ms-2"
                                onClick={() => handlePageChange(currentPage + 1)}
                                disabled={currentPage === totalPages}
                            >
                                Next
                            </button>
                        </Col>
                    </Row>
                )}
            </Container>
        </div>
    );
}

export default LatestInventoryContainer